import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function lteProp(propertyName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = parseFloat(control.value);
    let otherPropValue = parseFloat(control.parent?.get(propertyName)?.value);
    while (!otherPropValue && control.parent) {
      control = control.parent;
      otherPropValue = parseFloat(control.get(propertyName)?.value);
    }

    if (!Number.isFinite(value) || !Number.isFinite(otherPropValue)) {
      return null;
    }

    if (value <= otherPropValue) {
      return null;
    }

    return {
      lteProp: {
        propertyName,
        currentValue: value,
      },
    };
  };
}
